import { createTheme } from '@mui/material';
import { buildMuiAlertComponent } from './components/alert';
import { buildMuiAutocompleteComponent } from './components/autocomplete';
import { buildMuiBreadcrumbsComponent } from './components/breadcrumbs';
import { buildMuiButtonComponent } from './components/button';
import { buildMuiCheckboxComponent } from './components/checkbox';
import { buildMuiChipComponent } from './components/chip';
import { buildMuiFormControlComponent, buildMuiFormHelperTextComponent } from './components/form';
import { buildMuiMenuComponent, buildMuiMenuItemComponent } from './components/menu';
import { buildMuiModalComponent } from './components/modal';
import { buildMuiPaperComponent } from './components/paper';
import { buildPickersComponents } from './components/pickers';
import { buildMuiRadioComponent } from './components/radio';
import { buildMuiSelectComponent } from './components/select';
import { buildMuiSliderComponent } from './components/slider';
import { buildMuiSwitchComponent } from './components/switch';
import { buildMuiTabComponent } from './components/tab';
import {
  buildMuiInputBaseComponent,
  buildMuiInputLabelComponent,
  buildMuiTextFieldComponent,
} from './components/textfield';
import { buildMuiTooltipComponent } from './components/tooltip';
import { buildMuiTypographyComponent, buildTypography } from './components/typography';
import { buildMuiCssBaseline } from './cssBaseline';
import { buildPalette } from './palette';

const baseTheme = createTheme({
  components: {
    MuiCssBaseline: buildMuiCssBaseline(),
    MuiButton: buildMuiButtonComponent(),
    MuiTypography: buildMuiTypographyComponent(),
    MuiTextField: buildMuiTextFieldComponent(),
    MuiInputBase: buildMuiInputBaseComponent(),
    MuiInputLabel: buildMuiInputLabelComponent(),
    MuiSelect: buildMuiSelectComponent(),
    MuiPaper: buildMuiPaperComponent(),
    MuiMenu: buildMuiMenuComponent(),
    MuiMenuItem: buildMuiMenuItemComponent(),
    MuiChip: buildMuiChipComponent(),
    MuiFormHelperText: buildMuiFormHelperTextComponent(),
    MuiFormControl: buildMuiFormControlComponent(),
    MuiRadio: buildMuiRadioComponent(),
    MuiSwitch: buildMuiSwitchComponent(),
    MuiBreadcrumbs: buildMuiBreadcrumbsComponent(),
    MuiTooltip: buildMuiTooltipComponent(),
    MuiAlert: buildMuiAlertComponent(),
    MuiTab: buildMuiTabComponent(),
    MuiModal: buildMuiModalComponent(),
    MuiSlider: buildMuiSliderComponent(),
    MuiAutocomplete: buildMuiAutocompleteComponent(),
    MuiCheckbox: buildMuiCheckboxComponent(),
    ...buildPickersComponents(),
  },
  palette: buildPalette(),
  typography: buildTypography(),
});

const customerTheme = createTheme(baseTheme, {
  palette: {
    secondary: {
      main: '#f18a00', // secondary100
      light: '#FB9212',
      dark: '#C66700',
      contrastText: '#FFFFFF',
      30: '#ffd7b5',
      10: '#ffe8d4',
    },
  },
});

export const theme = __APP_STYLE__ === 'customer' ? customerTheme : baseTheme;
